import { Paper, PaperProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'Scrollbar' })(theme => ({
	root: {
		'& .os-scrollbar-vertical': { width: '7px', padding: '0px' },
		'&.os-theme-dark': {
			overflow: 'hidden !important',
			'& .os-scrollbar': {
				'& .os-scrollbar-track': {
					'& .os-scrollbar-handle': {
						background: theme.palette.scrollbar.dark
					}
				}
			}
		},
		'&.os-theme-light': {
			overflow: 'hidden !important',
			'& .os-scrollbar': {
				'& .os-scrollbar-track': {
					'& .os-scrollbar-handle': {
						background: theme.palette.scrollbar.light
					}
				}
			}
		}
	}
}));

const useStylesSelectMenuScrollbar = makeStyles({ name: 'SelectMenuScrollbar' })(theme => ({
	header: {
		padding: '6px 16px'
	},
	paper: {
		display: 'flex',
		flexDirection: 'column'
	},
	root: {
		flexGrow: 1,
		'&.os-theme-dark, &.os-theme-light': {
			'& .os-scrollbar-vertical': {
				width: '17px',
				padding: '10px 10px 10px 0px'
			}
		}
	}
}));

export type SkodaScrollbarProps = {
	className?: string;
	style?: React.CSSProperties;
	light?: boolean;
	children?: React.ReactNode;
};

export const SkodaScrollbars = ({ className, style, children, light }: SkodaScrollbarProps) => {
	const theme = useTheme();
	const useLightScrollbar = theme.palette.mode === 'dark' || light;

	let { classes: styles, cx } = useStyles();

	return (
		<OverlayScrollbarsComponent
			style={style}
			className={cx(styles.root, className)}
			options={{
				overflowBehavior: { x: 'hidden' },
				className: useLightScrollbar ? 'os-theme-light' : 'os-theme-dark'
			}}>
			{children}
		</OverlayScrollbarsComponent>
	);
};

export type SkodaSelectMenuPaperProps = PaperProps & {
	menuHeader: React.ReactNode
};

export const SkodaSelectMenu = React.forwardRef<HTMLDivElement, SkodaSelectMenuPaperProps>(({ children, menuHeader, className, ...props }, ref) => {
	let { classes: styles, cx } = useStylesSelectMenuScrollbar();
	return (
		<Paper className={cx(styles.paper, className)} {...props} ref={ref}>
			{menuHeader &&
				<div className={styles.header}>
					{menuHeader}
				</div>}
			<SkodaScrollbars className={styles.root}>
				{children}
			</SkodaScrollbars>
		</Paper>
	);
});
